"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * A method to get the previous state of a component.
 * @returns
 */
const usePreviousState = (value) => {
    const ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        ref.current = value;
    });
    return ref.current;
};
exports.default = usePreviousState;
//# sourceMappingURL=usePreviousState.js.map